module.exports = __webpack_public_path__ + "static/media/2d-flag.49e84331.png";